export interface AiBoxProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  headerRow?: React.ReactNode
  withIcon?: boolean
}
